import { useLocation } from "react-router-dom";
import { useGetShopByIdQuery } from "../../features/shop/shopApiSlice";
import { Navbarapi } from "../../constants/jsonConstant";
import {
  getActiveRouteName,
  getManagedShopId,
  getManagedShopRouteName,
} from "../../utils/navbar";

export const useNavbarRouteLabel = () => {
  const location = useLocation();
  const managedShopId = getManagedShopId(location.pathname);
  const { currentData: managedShopResponse } = useGetShopByIdQuery(
    managedShopId || "",
    { skip: !managedShopId },
  );
  const managedShop =
    managedShopResponse?.data?.Shop ||
    managedShopResponse?.Shop ||
    managedShopResponse?.data;

  return (
    getManagedShopRouteName(managedShop) ||
    getActiveRouteName(location.pathname, Navbarapi)
  );
};